import { createAction } from '@reduxjs/toolkit';

import { getFailurePayload } from 'modules/utils';

import * as actionTypes from './actionTypes';

export const fetchTranslations = createAction(actionTypes.FETCH_TRANSLATIONS, (url: string, language: string) => ({
  payload: {
    request: {
      method: 'GET',
      url: `${url}&language=${language}`,
    },
  },
}));

export const fetchTranslationsSuccess = createAction(
  actionTypes.FETCH_TRANSLATIONS_SUCCESS,
  (translations: Record<string, string>) => ({
    payload: { translations },
  })
);

export const fetchTranslationsFailure = createAction(actionTypes.FETCH_TRANSLATIONS_FAILURE, getFailurePayload);
